import React, { useEffect, useState } from "react";
import Layout1 from "../../Layouts/Layout1";
import FilterScreenModel from "../common/FilterScreenModel/FilterScreenModel";
import agency4 from "../../assets/agency-4.png";
import agent2 from "../../assets/agent-2.png";
import { toast } from "react-toastify";
import axiosInstance from "../../apiInstances/axiosInstance";
import {
  useSearchParams,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import Savepropertypopup from "../savepropertypopup/savepropertypopup";
import { AuthModal } from "../../models/AuthModal";
import FilterNavTab from "../common/FilterNavTab/FilterNavTab";
import { PropertyCardList } from "../common/PropertyCard/PropertyCard";
import VerticalAds from "../Adds/VerticalAds";
import RecentSoldProperties from "../common/RecentSoldProperties/RecentSoldProperties";
import { normalizePropertyList } from "../../utils/normalizePropertyList";
import { PropertyCardSkeletonList } from "../Skeleton/PropertyCardSkeleton";
import LayoutContainer from "../../Layouts/LayoutContainer";

const BuyPropertySearch = () => {
  const search = useLocation().pathname.split("/")?.[3];
  // //console.log("🚀 ~ BuyProperty ~ search---------------:", search);

  const [AuthPopUp, setAuthPopUp] = useState(false);
  const [savepropertypopup, setSavepropertypopup] = useState(false);
  const [IsOpen, setIsOpen] = useState(false);
  const [Searchindata, setSearchindata] = useState([]);
  const [BuyPropertyData, setBuyPropertyData] = useState([]);
  //console.log("🚀 ~ BuyPropertySearch ~ BuyPropertyData*****************************:", BuyPropertyData)
  // console.log(
  //   "🚀 ~ BuyPropertySearch ~ BuyPropertyData----------------->:",
  //   BuyPropertyData
  // );
  const [isLoading, setIsLoading] = useState(false);
  const [first, setfirst] = useState("");
  const onClose = () => setSavepropertypopup(false);
  const isAuthanticate = localStorage.getItem("Token");
  // const [query, setQuery] = useState("");

  const navigate = useNavigate();
  const typePriceBed = [
    {
      name: "Property type",
      id: "Property",
    },
    {
      name: "Price",
      id: "Price",
    },
    {
      name: "Bed",
      id: "Bed",
    },
  ];
  const allpropertyid =
    BuyPropertyData.length > 0 &&
    BuyPropertyData.map((data) => {
      if (data?._id) {
        return data?.id;
      }
      return data.id;
    });

  const [Filter, setFilter] = useState({
    search: "",
    category: "",
    status: "Active",
    agent: "",
    sort_by: "",
    serachbyaddress: "",
  });
  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  };

  let [data] = useSearchParams();
  const encryptedData = data.get("encryptedData");
  const [ads, setAds] = useState([]);
  const GetAllListingData = async (Filter) => {
    setIsLoading(true);
    await axiosInstance
      .post("Agency/viewAllProperty", {
        status: Filter?.status,
      })
      .then((res) => {
        const mydata = res?.data?.data || [];
        if (res?.data?.status) {
          const enriched = mydata.map((obj) => ({
            ...obj,
            agencyImg: agency4,
            agentImg: agent2,
          }));

          const normalized = normalizePropertyList(enriched);

          setIsLoading(false);
          setBuyPropertyData(normalized);
          setSearchindata(normalized);
        } else {
          toast.error(res?.data?.message);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
        setIsLoading(false);
      });
  };

  const searchValue = () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    axiosInstance
      .post("/searchByAddress", { key: search, status: "Active", userId: userData?.id || null })
      .then((res) => {
        const mydata = res?.data?.data || [];
        const normalized = normalizePropertyList(mydata);
        setBuyPropertyData(normalized);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    searchValue();
  }, []);

  const getid = (value) => {
    setfirst(value);
  };

  const customsort = (value) => {
    if (value === "DE") {
      const nextinspection = Searchindata.filter(
        (data) => new Date() < new Date(data.inpection_time),
      );
      if (nextinspection != "") {
        setBuyPropertyData(nextinspection);
      } else {
        alert("inpection is blank");
      }
    } else {
      value === "priceDescending" || value === "priceAsending"
        ? value === "priceDescending"
          ? setBuyPropertyData((prevData) =>
            [...prevData].sort((a, b) => b.price - a.price),
          )
          : setBuyPropertyData((prevData) =>
            [...prevData].sort((a, b) => a.price - b.price),
          )
        : value === "dateDescending"
          ? setBuyPropertyData((prevData) =>
            [...prevData].sort(
              (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
            ),
          )
          : setBuyPropertyData((prevData) =>
            [...prevData].sort(
              (a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt),
            ),
          );
    }
  };

  useEffect(() => {
    customsort(Filter?.sort_by);
  }, [Filter?.sort_by]);

  const filterData = (searchTerm) => {
    const filteredArray = Searchindata.filter((obj) => {
      const allValue = `${obj.street_address_name
        .trim()
        .toLowerCase()} ${obj.street_address_number.toString()}`;
      searchTerm = searchTerm.toLowerCase();
      // Check if the name or ID contains all characters from the search term
      const searchCharacters = searchTerm.split("");
      return searchCharacters.every((char) => allValue.includes(char));
    });
    setBuyPropertyData(filteredArray);
  };
  return (
    <Layout1>
      <div className="bg-white border-t z-50 shadow-sm">

        <FilterNavTab currentTab={"Buy"} dataCount={BuyPropertyData?.length} />
      </div>
      {/* <InPostAd /> */}

      <LayoutContainer>
        <div className="w-full flex flex-col lg:flex-row items-start gap-8 my-10 lg:my-16">
          {/* Content Section */}
          <div className="flex flex-col gap-6 w-full flex-1 min-w-0 lg:max-w-[910px]">
            {isLoading ? (
              <PropertyCardSkeletonList count={5} />
            ) : (
              <>
                <PropertyCardList
                  PropertyData={BuyPropertyData}
                  setPropertyData={setBuyPropertyData}
                  style="mb-5"
                  adsList={ads.betweenAds}
                />
              </>
            )}
          </div>

          {/* Sidebar Section */}
          <div className="hidden sticky top-6 lg:block shrink-0 lg:w-[265px] xl:w-[300px] 2xl:w-[360px]">
            <div className="w-full">
              {/* <PropertyShowcaseCard
                  PropertyData={RentPropertyData}
                  scrollToDiv={scrollToDiv}
                  sendDataToParent={handleDataFromChild}
                /> */}
              {ads?.verticalAds &&
                ads?.verticalAds.length > 0 &&
                ads?.verticalAds?.map((items, index) => {
                  return (
                    <VerticalAds style="my-10" adsList={items} key={index} />
                  );
                })}
            </div>
          </div>
        </div>

        {/* Featured news, tips and guides  */}
        {/* <div className="container max-w-3xl py-10 pr-4"> */}
        {/* <TipsAndGuides /> */}
        {/* </div> */}

        <div>{/* <RecentlySoldProperties /> */}</div>

        {/* Talk to broker */}
        {/* <div className="max-w-3xl pr-4 pb-[60px]"> */}
        {/* <TalkToBroker /> */}
        {/* </div> */}
        {/* Enquired section */}
        {/* <div
          id="Enquiry"
          ref={targetDivRef}
          className="max-w-3xl pr-4 pb-[60px]"
        >
          <AgentContactCard AgentData={getUserCardData} />
        </div> */}
      </LayoutContainer>

      <RecentSoldProperties />
      {/* ----------------------------popup savesearch-------------- */}
      {savepropertypopup ? (
        <Savepropertypopup allpropertyid={allpropertyid} onClose={onClose} />
      ) : null}

      {/* -----------------popup login-------------------- */}
      {AuthPopUp ? (
        <AuthModal open={AuthPopUp} onClose={() => setAuthPopUp(false)} />
      ) : null}

      {/* ---------- Filter Screen Model ---------- */}

      <FilterScreenModel
        setIsOpen={setIsOpen}
        IsOpen={IsOpen}
        currentTab={"Buy"}
        id={first}
        dataCount={BuyPropertyData?.length}
      />
    </Layout1>
  );
};

export default BuyPropertySearch;
